/** external */
import React from "react";
import PropTypes from "prop-types";
/** internal */
import { WORKSHEET_MODES } from "Worksheet/modules/WorksheetConstants";
/** relative */
import classes from "./TeacherEvaluation.scss";
import SectionFeed from "../SectionFeed";

const TeacherEvaluation = props => {
  const {
    data,
    submissions,
    mode,
    setWorksheetContainerRef,
    setScrollContainerRef,
    setQuestionRef,
    isSubmitted,
    assignmentId,
    isQueriesV2Enabled,
  } = props;

  return (
    <div className={classes.parentContainer} ref={setWorksheetContainerRef}>
      <div className={classes.container}>
        <div className={classes.content} ref={setScrollContainerRef}>
          <SectionFeed
            sections={data}
            mode={mode}
            submissions={submissions}
            setQuestionRef={setQuestionRef}
            isSubmitted={isSubmitted}
            assignmentId={assignmentId}
            isQueriesV2Enabled={isQueriesV2Enabled}
          />
        </div>
      </div>
    </div>
  );
};

TeacherEvaluation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  submissions: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.oneOf(WORKSHEET_MODES),
  assignmentId: PropTypes.string,
  isQueriesV2Enabled: PropTypes.bool,
};

export default TeacherEvaluation;
